module.exports = __webpack_public_path__ + "static/media/organbgMofi.6ff6f819.png";